import { SearchBar as SearchBarBase } from '@jagad/ui';
import type { SearchBarProps as SearchBarBaseProps } from '@jagad/ui';
import { useTranslation } from 'react-i18next';

type SearchBarProps = Omit<SearchBarBaseProps, 'placeholder'> & {
    placeholder?: string;
};

const SearchBar = ({ placeholder, ...props }: SearchBarProps) => {
    const { t } = useTranslation();
    return (
        <SearchBarBase
            {...props}
            placeholder={placeholder ?? t('components.searchBar.placeholder')}
        />
    );
};

export default SearchBar;
